// extracted by mini-css-extract-plugin
export default {"modal":"H5scUCmy55J_FSxWhdP4__modal___","modalImgHeight":"jTOcoVzr551yfx3Arh8R__modalImgHeight___"};